import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Cookie, Settings, BarChart3, Target } from 'lucide-react';

const Cookies = () => {
  return (
    <div className="pb-16 bg-brand-bone min-h-screen" data-testid="cookies-page">
      {/* Hero */}
      <section className="bg-brand-black/[0.03] py-12 md:py-20 border-b border-brand-cobalt/10">
        <div className="max-w-4xl mx-auto px-4">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-sm text-brand-cobalt hover:text-brand-cobalt/80 mb-6"
          >
            <ArrowLeft size={16} />
            Volver al inicio
          </Link>
          <h1 className="font-display text-3xl md:text-5xl tracking-tight mb-4 text-brand-black">
            Política de Cookies
          </h1>
          <p className="text-brand-black/60 text-lg">
            Información sobre el uso de cookies en nuestro sitio
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-12 md:py-16">
        <div className="max-w-4xl mx-auto px-4">
          <div className="prose prose-lg max-w-none">
            <p className="text-brand-black/80 leading-relaxed mb-8">
              El sitio web de Alphatica utiliza cookies y tecnologías similares para mejorar la experiencia
              de navegación.
            </p>

            <h2 className="font-display text-xl md:text-2xl mt-10 mb-4 text-brand-cobalt">¿Qué permiten las cookies?</h2>
            
            <div className="grid md:grid-cols-3 gap-4 mb-8">
              <div className="brand-card hybrid-glow p-5 rounded-lg text-center">
                <Settings className="text-brand-cobalt mx-auto mb-3" size={28} />
                <h3 className="font-medium text-sm mb-1 text-brand-black">Preferencias</h3>
                <p className="text-brand-black/60 text-xs">Recordar preferencias del usuario</p>
              </div>
              <div className="brand-card hybrid-glow p-5 rounded-lg text-center">
                <BarChart3 className="text-brand-cobalt mx-auto mb-3" size={28} />
                <h3 className="font-medium text-sm mb-1 text-brand-black">Análisis</h3>
                <p className="text-brand-black/60 text-xs">Analizar el comportamiento de navegación</p>
              </div>
              <div className="brand-card hybrid-glow p-5 rounded-lg text-center">
                <Target className="text-brand-cobalt mx-auto mb-3" size={28} />
                <h3 className="font-medium text-sm mb-1 text-brand-black">Funcionalidad</h3>
                <p className="text-brand-black/60 text-xs">Mejorar la funcionalidad del sitio</p>
              </div>
            </div>

            <h2 className="font-display text-xl md:text-2xl mt-10 mb-4 text-brand-cobalt">Cookies de terceros</h2>
            <p className="text-brand-black/80 mb-6">
              Las cookies también pueden ser utilizadas por servicios de terceros como herramientas de
              análisis y publicidad digital.
            </p>

            <h2 className="font-display text-xl md:text-2xl mt-10 mb-4 text-brand-cobalt">Control de cookies</h2>
            <div className="brand-card hybrid-glow border-l-4 border-amber-500 p-4 mb-6">
              <p className="text-brand-black/80 text-sm">
                El usuario puede deshabilitar las cookies desde la configuración de su navegador, aunque
                algunas funciones del sitio podrían verse afectadas.
              </p>
            </div>

            <h2 className="font-display text-xl md:text-2xl mt-10 mb-4 text-brand-cobalt">Cómo gestionar las cookies</h2>
            <p className="text-brand-black/80 mb-4">
              Puedes configurar tu navegador para rechazar todas las cookies o para que te avise 
              cuando se envía una cookie. A continuación te indicamos cómo hacerlo en los navegadores más comunes:
            </p>
            <ul className="space-y-2 text-brand-black/80">
              <li className="flex items-start gap-2">
                <span className="text-brand-petroleum">•</span>
                <strong className="text-brand-black">Chrome:</strong> Configuración → Privacidad y seguridad → Cookies
              </li>
              <li className="flex items-start gap-2">
                <span className="text-brand-petroleum">•</span>
                <strong className="text-brand-black">Firefox:</strong> Opciones → Privacidad y seguridad → Cookies
              </li>
              <li className="flex items-start gap-2">
                <span className="text-brand-petroleum">•</span>
                <strong className="text-brand-black">Safari:</strong> Preferencias → Privacidad → Cookies
              </li>
              <li className="flex items-start gap-2">
                <span className="text-brand-petroleum">•</span>
                <strong className="text-brand-black">Edge:</strong> Configuración → Cookies y permisos del sitio
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Cookies;
